module.exports = __webpack_public_path__ + "assets/img/4_339_big.c49ae29c.jpg";